import { track } from "./index";

/**
 * Registra erros de API (5xx / rede) — campos alinhados ao guia do backend.
 */
export const trackApiError = (error) => {
  try {
    const status = error?.response?.status;
    const isNetwork = !error?.response;
    if (!isNetwork && !(status >= 500)) return;

    const config = error?.config || {};
    const path = String(config.url || "").split("?")[0].slice(0, 300);
    const baseURL = String(config.baseURL || "").replace(/\/+$/, "");
    const url = baseURL && path ? `${baseURL}${path.startsWith("/") ? path : `/${path}`}` : path;

    track("api_error", {
      message: String(error?.message || "").slice(0, 300),
      status: status || 0,
      url: url.slice(0, 500),
    });
  } catch {
    /* ignore */
  }
};
